<template>
	<div>
		<footer>
			<div class="decoration" v-if="!hideFooterDecoration"></div>
			<div class="container">
				<div class="row">
					<div class="col-12">
						<div class="row">
							<div class="col-12 col-md-4  mb-5">
								<img src="@/assets/logo-dark.png" alt="" class="logo" />
								<div class="mt-4">
									<div>
										Av. Luis Battle Berres 6096
									</div>
									<div>
										Telefono: 2 312 2921
									</div>
									<div>
										Celular: 098 831 471
									</div>
									<div>
										Horarios: <br>Lunes a jueves de 9:00 a 12:30 y 13:30 a 18:00<br>
										Los viernes es de 8:30 a 12:30 y 13:30 a 17:30
									</div>
									<div>
										Whatsaap: 096108889
									</div>
									<div>E-mail: carliturcasasrodantes@gmail.com</div>
								</div>

								<div class="redes">
									<a href="https://www.facebook.com/p/Carlitur-Casas-Rodantes-100063802892645" target="_blank">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-brand-facebook"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<path
												d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3"
											></path>
										</svg>
									</a>
									<a href="https://www.instagram.com/carliturcasasrodantes" target="_blank">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-brand-instagram"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<rect x="4" y="4" width="16" height="16" rx="4"></rect>
											<circle cx="12" cy="12" r="3"></circle>
											<line x1="16.5" y1="7.5" x2="16.5" y2="7.501"></line>
										</svg>
									</a>
								</div>
							</div>
							<div class="col-12 col-md-2 mb-5 mt-4">
								<h4 class="footer-title"></h4>
								<router-link tag="a" :to="`/`"> Inicio </router-link><br />
								<router-link tag="a" :to="`/lista-productos`"> Productos </router-link><br />
								<router-link tag="a" :to="`/tienda`"> Tienda online </router-link><br />
								<router-link tag="a" :to="`/quienes-somos`"> Quienes somos </router-link><br />
								<!-- <router-link tag="a" :to="`/preguntas-frecuentes`"> Preguntas frecuentes </router-link
								><br />
								<router-link tag="a" :to="`/politica-privacidad`"> Política de privacidad</router-link
								><br /> -->
								<router-link tag="a" :to="`/contacto`">
									Contacto
								</router-link>
							</div>
							<div class="col-12 col-md-3  mb-5 mt-4">
								<h4 class="footer-title">Productos</h4>
								<router-link tag="a" v-for="item in camperCategories" :key="item.id"  :to="`/lista-productos/${item.slug}`" class="footer-link" > {{item.title}} </router-link><br />
							</div>
							<div class="col-12 col-md-3  mb-5 mt-4">
								<h4 class="footer-title">Tienda Online</h4>
								<router-link tag="a" v-for="item in categories" :key="item.id"  :to="`/tienda/${item.slug}`" class="footer-link" > {{item.title}} </router-link><br />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container-fluid credits">
				<div class="container">
					<div class="row">
						<div class="col">
							<div class="d-flex align-items-center justify-content-between">
								<div>
									<div class="payment-methods">
										<div
											class="payment"
											:style="
												`background-image:url(${require('@/assets/img/icon-payment-visa.png')})`
											"
										></div>
										<div
											class="payment"
											:style="
												`background-image:url(${require('@/assets/img/icon-payment-master.png')})`
											"
										></div>
										<div
											class="payment"
											:style="
												`background-image:url(${require('@/assets/img/icon-payment-oca.png')})`
											"
										></div>
										<div
											class="payment"
											:style="
												`background-image:url(${require('@/assets/img/icon-payment-abitab.png')})`
											"
										></div>
										<div
											class="payment"
											:style="
												`background-image:url(${require('@/assets/img/icon-payment-redpagos.png')})`
											"
										></div>
										<div
											class="payment"
											:style="
												`background-image:url(${require('@/assets/img/icon-payment-brou.png')})`
											"
										></div>
									</div>
								</div>
								<div>Carlitur Casas Rodantes Copyright &copy; {{ year }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "Footer",
	props:['hideFooterDecoration'],
	data() {
		return {
			year: new Date().getFullYear(),
			camperCategories: [],
			categories: []
		}
	},
	mounted(){
		this.$apollo
			.query({
				query: gql`
					query{
						camperCategories{
							id
							title
							slug
						}
						categories{
							data{
							id title slug
							}
						}
					}
				`,
				fetchPolicy: 'network-only',
			})
			.then(({ data }) => {
				this.camperCategories = data.camperCategories
				this.categories = data.categories.data
			})
	}
}
</script>

<style scoped lang="scss">
footer {
	width: 100%;
	color: #fff;
	line-height: 24px;

	background-image: url("~@/assets/img/footer.png");
	background-size: cover;
	background-position: center;
	position: relative;
	padding-top: 85px;
		// margin-top: 150px;

	.decoration {
		position: absolute;
		content: "";
		width: 100%;
		height: 193px;
		background-image: url("~@/assets/img/footer-shap-1.png");
		top: -186px;
		left: 0;
		z-index: 1;
		background-size: cover;
		background-repeat: no-repeat;
	}
}
.logo {
	max-height: 92px;
}
h5 {
	font-size: 15px;
}
.footer-title {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 6px;
}
a {
	color: #fff;
	line-height: 34px;
}
.fa {
	color: #cfcfcf;
}
.logo {
	max-width: 230px;
}
.credits {
	background-color: rgb(10, 11, 13);
	padding: 27px 0;
}
.footer-link{
	width: 100%;
	display: block;
	line-height: 16px;
    padding: 8px 0px;
}

.redes {
	margin-top: 20px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	flex-wrap: wrap;

	a {
		width: 44px;
		height: 44px;

		border: solid 1px #fff;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;

		svg {
			width: 28px;
			height: 28px;
		}
	}
}
.payment-methods {
	display: flex;
	align-items: center;
	align-items: center;
	gap: 3px;
	flex-wrap: wrap;

	.payment {
		width: 74px;
		height: 40px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center center;
	}
}

@media (max-width: 768px) {
	footer {
		text-align: center;
	}

	.redes,
	.payment-methods {
		justify-content: center;
	}
}
</style>
